import BASE_URL from "../config";

const authHeaders = () => {
  const token = localStorage.getItem("adminToken");
  return token
    ? { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
};

const parse = async (response) => {
  const result = await response.json().catch(() => ({}));
  return { ok: response.ok, ...result };
};

// A product's FAQs, in display order. `productId` may be the id or the slug.
export const getProductFaqs = async (productId) =>
  parse(await fetch(`${BASE_URL}/products/${productId}/faqs`, { headers: authHeaders() }));

// Admin: replaces the product's whole FAQ list; the array order is the display order.
export const saveProductFaqs = async (productId, faqs) =>
  parse(
    await fetch(`${BASE_URL}/products/${productId}/faqs`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({ faqs }),
    })
  );
